import { categories } from '@/mocks/manhwa';

interface CategoriesProps {
  onPick: (c: string) => void;
}

export default function Categories({ onPick }: CategoriesProps) {
  return (
    <section id="category" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">主题分类</h2>
          <p className="mt-2 text-sm text-foreground-600">从奇幻到竞技，总有一种题材能戳中你的追更欲。</p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <button
              key={c.name}
              onClick={() => onPick(c.name)}
              className="group flex items-center gap-4 rounded-lg bg-background-100/70 p-4 text-left transition-colors hover:bg-primary-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`} />
              </span>
              <span className="min-w-0">
                <span className="block font-bold text-foreground-950">{c.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-600">{c.desc}</span>
              </span>
              <span className="ml-auto whitespace-nowrap rounded-full bg-background-50 px-2.5 py-1 text-xs text-secondary-700">
                {c.count} 部
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}